module.exports = __webpack_public_path__ + "img/search.8fd1e801.svg";